//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimelineItemCard from "../utils/timeline-card.vue";
import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import { every, isEmpty, isPlainObject } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogField",
  components: {
    TimelineItemCard
  },
  mixins: [ChangelogMixin],
  props: {
    value: {
      type: null,
      required: true
    },
    operation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    insertionTimestamp: {
      type: String,
      required: true
    },
    showValueOnNewLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCommon() {
      return this.type === "common-field";
    },
    isReferrer() {
      return this.field === "referrerId";
    },
    fieldText() {
      const fieldTexti18nParser = {
        givenName: "account.givenName",
        familyName: "account.familyName",
        dateOfBirth: "account.birthDate",
        phoneNumber: "account.phoneNumber",
        referrerId: "global.doorr.referrer",
        email: "account.email",
        value: "global.words.value"
      };
      if (this.isReferrer) return this.$tc("global.doorr.referrer", 1);
      return `${this.$t(fieldTexti18nParser[this.field]) || this.field}:`;
    }
  },
  methods: {
    isEmpty(value) {
      return isPlainObject(value) ? every(value, isEmpty) : isEmpty(value);
    },
    fieldValue(value) {
      if (this.isEmpty(value)) return this.$t("global.words.empty");
      if (value["formatted-address"]) return value["formatted-address"];
      if (this.value.fieldType && this.value.fieldType === "monetary" || this.field === "value") return this.$options.filters.formatMoneyValueLong(value);
      return this.isReferrer ? this.extractNameFromValue(value) : value;
    }
  }
});